export enum AnnoTypeEnum {
  RULER = 'Ruler',
  CROSS_RULER = 'CrossRuler',
  FREEHAND = 'Freehand',
  LINE = 'Line',
  RECTANGLE = 'Rectangle',
  ELLIPSE = 'Ellipse',
  CURVE = 'Curve'
}
